import { format } from "date-fns";

import { getDateFnsLocale } from "@/lib/date-fns-locale";
import type { AppLocale } from "@/lib/locale/resolve-effective-locale";

/** Full day label shared by the map heading and the day sidebar. */
export const riskPictureDayTitle = (date: string, locale: AppLocale): string => {
  const title = format(new Date(date), "eeee d MMMM", {
    locale: getDateFnsLocale(locale),
  });
  return title.charAt(0).toUpperCase() + title.slice(1);
};
